import { useEffect, useState } from "react";

const useZoomLevel = () => {
  const [zoom, setZoom] = useState<number>(window.devicePixelRatio);

  useEffect(() => {
    const handleZoom = () => {
      setZoom(window.devicePixelRatio);
    };

    window.addEventListener("resize", handleZoom);

    return () => {
      window.removeEventListener("resize", handleZoom);
    };
  }, []);

  return zoom;
};

export default useZoomLevel
